import * as actionTypes from "../actionTypes.js";

const initialState = {
  brokersList: null,
  brokersDropdownList: null,
  complianceVectorsList: null,
  complianceVectorsDropdownList: null,
  companyVectorPrefsList: null,
  companyVectorPrefsSummaryList: null,
  companyVectorPrefsDetailList: null,
  systemValidationRulesList: null,

  usitcHtsCodesList: null,
  usitcHtsCodesDropdownList: null,
  ustrExclusionsList: null,
  usitcRevisionsList: null,
  usitcRevisionsDropdownList: null,
  usitcSpiRatesList: null,
  usitcChapter99MappingsList: null,

  assemblySessionsList: null,
  assemblyDocumentsList: null,

  stagingEntriesList: null,
  stagingDocumentsList: null,
  customsEntriesList: null,
  entryDocumentsList: null,
  pivotMastersList: null,
  pivotRowsList: null,
  ciMastersList: null,
  ciLinesList: null,
  form7501HeadersList: null,
  form7501LinesList: null,
  bolHeadersList: null,
  scNodesList: null,
  scNodeContentList: null,
  scNodeRevisionStatusList: null,
  scSegmentationRunsList: null,
  scPageFurnitureLogList: null,
  scRuleFrameworksList: null,
  scRuleFrameworkMembersList: null,
  scPseudocodeList: null,
  scParseReviewsList: null,
  scCh99RulesList: null,
  scRuleInteractionsList: null,
  scHtsCh99MappingsList: null,
};

const businessCoreTradeDefenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_BROKERS_BIZ_CORE_TD:
      return { ...state, brokersList: action.payload };
    case actionTypes.GET_BROKERS_DROPDOWN_BIZ_CORE_TD:
      return { ...state, brokersDropdownList: action.payload };
    case actionTypes.CLEAR_BROKERS_DROPDOWN_BIZ_CORE_TD:
      return { ...state, brokersDropdownList: null };
    case actionTypes.GET_COMPLIANCE_VECTORS_BIZ_CORE_TD:
      return { ...state, complianceVectorsList: action.payload };
    case actionTypes.GET_COMPLIANCE_VECTORS_DROPDOWN_BIZ_CORE_TD:
      return { ...state, complianceVectorsDropdownList: action.payload };
    case actionTypes.CLEAR_COMPLIANCE_VECTORS_DROPDOWN_BIZ_CORE_TD:
      return { ...state, complianceVectorsDropdownList: null };
    case actionTypes.GET_COMPANY_VECTOR_PREFS_BIZ_CORE_TD:
      return { ...state, companyVectorPrefsList: action.payload };
    case actionTypes.GET_COMPANY_VECTOR_PREFS_SUMMARY_BIZ_CORE_TD:
      return { ...state, companyVectorPrefsSummaryList: action.payload };
    case actionTypes.GET_COMPANY_VECTOR_PREFS_BY_COMPANY_BIZ_CORE_TD:
      return { ...state, companyVectorPrefsDetailList: action.payload };
    case actionTypes.CLEAR_COMPANY_VECTOR_PREFS_DETAIL_BIZ_CORE_TD:
      return { ...state, companyVectorPrefsDetailList: null };
    case actionTypes.GET_SYSTEM_VALIDATION_RULES_BIZ_CORE_TD:
      return { ...state, systemValidationRulesList: action.payload };

    case actionTypes.GET_USITC_HTS_CODES_BIZ_CORE_TD:
      return { ...state, usitcHtsCodesList: action.payload };
    case actionTypes.GET_USITC_HTS_CODES_DROPDOWN_BIZ_CORE_TD:
      return { ...state, usitcHtsCodesDropdownList: action.payload };
    case actionTypes.CLEAR_USITC_HTS_CODES_DROPDOWN_BIZ_CORE_TD:
      return { ...state, usitcHtsCodesDropdownList: null };
    case actionTypes.GET_USTR_EXCLUSIONS_BIZ_CORE_TD:
      return { ...state, ustrExclusionsList: action.payload };
    case actionTypes.GET_USITC_REVISIONS_BIZ_CORE_TD:
      return { ...state, usitcRevisionsList: action.payload };
    case actionTypes.GET_USITC_REVISIONS_DROPDOWN_BIZ_CORE_TD:
      return { ...state, usitcRevisionsDropdownList: action.payload };
    case actionTypes.CLEAR_USITC_REVISIONS_DROPDOWN_BIZ_CORE_TD:
      return { ...state, usitcRevisionsDropdownList: null };
    case actionTypes.GET_USITC_SPI_RATES_BIZ_CORE_TD:
      return { ...state, usitcSpiRatesList: action.payload };
    case actionTypes.GET_USITC_CHAPTER_99_MAPPINGS_BIZ_CORE_TD:
      return { ...state, usitcChapter99MappingsList: action.payload };

    case actionTypes.GET_ASSEMBLY_SESSIONS_BIZ_CORE_TD:
      return { ...state, assemblySessionsList: action.payload };
    case actionTypes.GET_ASSEMBLY_DOCUMENTS_BIZ_CORE_TD:
      return { ...state, assemblyDocumentsList: action.payload };

    case actionTypes.GET_STAGING_ENTRIES_BIZ_CORE_TD:
      return { ...state, stagingEntriesList: action.payload };
    case actionTypes.GET_STAGING_DOCUMENTS_BIZ_CORE_TD:
      return { ...state, stagingDocumentsList: action.payload };
    case actionTypes.GET_CUSTOMS_ENTRIES_BIZ_CORE_TD:
      return { ...state, customsEntriesList: action.payload };
    case actionTypes.GET_ENTRY_DOCUMENTS_BIZ_CORE_TD:
      return { ...state, entryDocumentsList: action.payload };
    case actionTypes.GET_PIVOT_MASTERS_BIZ_CORE_TD:
      return { ...state, pivotMastersList: action.payload };
    case actionTypes.GET_PIVOT_ROWS_BIZ_CORE_TD:
      return { ...state, pivotRowsList: action.payload };
    case actionTypes.GET_CI_MASTERS_BIZ_CORE_TD:
      return { ...state, ciMastersList: action.payload };
    case actionTypes.GET_CI_LINES_BIZ_CORE_TD:
      return { ...state, ciLinesList: action.payload };
    case actionTypes.GET_FORM_7501_HEADERS_BIZ_CORE_TD:
      return { ...state, form7501HeadersList: action.payload };
    case actionTypes.GET_FORM_7501_LINES_BIZ_CORE_TD:
      return { ...state, form7501LinesList: action.payload };
    case actionTypes.GET_BOL_HEADERS_BIZ_CORE_TD:
      return { ...state, bolHeadersList: action.payload };

    case actionTypes.GET_SC_NODES_BIZ_CORE_TD:
      return { ...state, scNodesList: action.payload };
    case actionTypes.GET_SC_NODE_CONTENT_BIZ_CORE_TD:
      return { ...state, scNodeContentList: action.payload };
    case actionTypes.GET_SC_NODE_REVISION_STATUS_BIZ_CORE_TD:
      return { ...state, scNodeRevisionStatusList: action.payload };
    case actionTypes.GET_SC_SEGMENTATION_RUNS_BIZ_CORE_TD:
      return { ...state, scSegmentationRunsList: action.payload };
    case actionTypes.GET_SC_PAGE_FURNITURE_LOG_BIZ_CORE_TD:
      return { ...state, scPageFurnitureLogList: action.payload };

    case actionTypes.GET_SC_RULE_FRAMEWORKS_BIZ_CORE_TD:
      return { ...state, scRuleFrameworksList: action.payload };
    case actionTypes.GET_SC_RULE_FRAMEWORK_MEMBERS_BIZ_CORE_TD:
      return { ...state, scRuleFrameworkMembersList: action.payload };
    case actionTypes.GET_SC_PARSE_REVIEWS_BIZ_CORE_TD:
      return { ...state, scParseReviewsList: action.payload };
    case actionTypes.GET_SC_PSEUDOCODE_BIZ_CORE_TD:
      return { ...state, scPseudocodeList: action.payload };
    case actionTypes.GET_SC_CH99_RULES_BIZ_CORE_TD:
      return { ...state, scCh99RulesList: action.payload };
    case actionTypes.GET_SC_RULE_INTERACTIONS_BIZ_CORE_TD:
      return { ...state, scRuleInteractionsList: action.payload };
    case actionTypes.GET_SC_HTS_CH99_MAPPINGS_BIZ_CORE_TD:
      return { ...state, scHtsCh99MappingsList: action.payload };

    case actionTypes.LOG_OUT:
      return initialState;

    default:
      return state;
  }
};

export default businessCoreTradeDefenceReducer;
